module.exports = __webpack_public_path__ + "img/icon-cardgames-white.410e1499.svg";